import React from "react";
import { useLocation } from "react-router-dom";

const LINKS = [
  { href: "/maintenance/ocpi", label: "Partners", match: (p: string) => p === "/maintenance/ocpi" || p.startsWith("/maintenance/ocpi/partners") },
  { href: "/maintenance/ocpi/roles", label: "Access roles", match: (p: string) => p.startsWith("/maintenance/ocpi/roles") },
  { href: "/maintenance/ocpi/logs", label: "Request log", match: (p: string) => p.startsWith("/maintenance/ocpi/logs") },
  { href: "/maintenance/ocpi/settings", label: "Settings & publishing", match: (p: string) => p.startsWith("/maintenance/ocpi/settings") },
];

const OcpiSubnav: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <nav className="ocpi-subnav" aria-label="OCPI sections">
      {LINKS.map((l) => (
        <a key={l.href} href={l.href} className={l.match(pathname) ? "on" : ""} aria-current={l.match(pathname) ? "page" : undefined}>
          {l.label}
        </a>
      ))}
    </nav>
  );
};

export default OcpiSubnav;
